import React, { Component } from 'react';
import img from '../images/about.png';

class About extends Component {
    render() {
        return (
            <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6" id='about'>
                <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left" data-aos="fade-up">
                    <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                        <img alt="card img" className="rounded-t float-right" src={img} />
                    </div>
                    <div className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8" data-aos="zoom-in" data-aos-delay="500">
                        <h3 className="text-3xl text-red-600 font-bold">Bienvenue sur L9itha? votre destination pour l'achat et la vente de produits de qualité.</h3>
                        <div>
                            <p className='my-3 text-l text-gray-600 font-semibold'>
                                Nous sommes passionnés par la mise en relation des acheteurs et des vendeurs,
                                en offrant une plateforme conviviale pour faciliter toutes vos transactions. Que vous soyez un acheteur à la recherche de
                                l'article parfait ou un vendeur souhaitant élargir sa portée, nous sommes là pour vous accompagner à chaque étape. Notre mission est de
                                créer une communauté dynamique où chacun peut découvrir des produits innovants et profiter d'une expérience d'achat inégalée.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;
